import config from 'src/appConfig';
import { segmentTrack } from 'src/helpers/segment';
import { rudderstackTrack } from 'src/helpers/rudderstack';
const track = (eventType: string, options: $TODOFIXME = {}) => {
  config?.segment?.enabled
    ? segmentTrack(eventType, options)
    : rudderstackTrack(eventType, options);
};
export default track;
